import { useEffect, useRef, useState } from "react";

export function UserMenu({
  initials,
  displayName,
  email,
}: {
  initials: string;
  displayName: string;
  email: string;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        title={displayName || email}
        aria-label="Account menu"
        aria-haspopup="menu"
        aria-expanded={open}
        className="avatar"
        style={{
          background: "var(--accent)",
          color: "white",
          border: 0,
          width: 28,
          height: 28,
          borderRadius: "50%",
          fontSize: 11,
          fontWeight: 600,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {initials || "?"}
      </button>
      {open ? (
        <div
          role="menu"
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            right: 0,
            minWidth: 240,
            background: "var(--bg)",
            border: "1px solid var(--border)",
            borderRadius: 8,
            boxShadow: "var(--shadow)",
            padding: 4,
            zIndex: 60,
          }}
        >
          <div style={{ padding: "8px 12px", borderBottom: "1px solid var(--border)" }}>
            <div style={{ fontSize: 13, fontWeight: 500 }}>{displayName || email}</div>
            <div style={{ fontSize: 11, color: "var(--text-3)", marginTop: 2 }}>{email}</div>
          </div>
          <div style={{ height: 1, background: "var(--border)", margin: "4px 0" }} />
          {/* Use a real form POST so the browser follows the 302 redirect to
              Xamun's end_session URL natively (fetch with credentials wouldn't
              top-level navigate). The /api/auth/logout endpoint destroys the
              session, clears the cookie, then 302s. */}
          <form action="/api/auth/logout" method="post" style={{ margin: 0 }}>
            <button
              type="submit"
              role="menuitem"
              style={{
                width: "100%",
                textAlign: "left",
                background: "transparent",
                border: 0,
                padding: "8px 12px",
                borderRadius: 6,
                cursor: "pointer",
                font: "inherit",
                fontSize: 13,
                color: "var(--text)",
              }}
            >
              Sign out
            </button>
          </form>
        </div>
      ) : null}
    </div>
  );
}
